import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { WarehouseInventory } from '../components/admin/WarehouseInventory';
import { Button } from '../components/ui/button';
import { HelpCircle } from 'lucide-react';

export default function WarehousePage() {
  const { user, loading } = useAuth();
  if (loading) return <p data-testid="warehouse-auth-loading">Loading…</p>;
  if (!user) return <Navigate to="/login" replace/>;
  return <main className="min-h-screen bg-[#111] text-white px-4 sm:px-8 py-7 pb-32 [overflow-wrap:anywhere]" data-testid="warehouse-page"><div className="max-w-5xl mx-auto space-y-8">
    <nav className="flex flex-wrap items-center gap-4">
      <Link to="/company-manager-dashboard?dept=procurement" className="text-[#C9A962] text-sm" data-testid="warehouse-back">← Procurement & Supply</Link>
      <Link to="/suppliers" className="text-[#C9A962] text-sm" data-testid="warehouse-suppliers-link">Brokers & Providers</Link>
      <Button variant="outline" onClick={() => window.dispatchEvent(new CustomEvent('necs:open-support-chat'))} data-testid="warehouse-help"><HelpCircle className="w-4 h-4 mr-2"/>Support</Button>
    </nav>
    <header><p className="text-xs text-[#C9A962]" data-testid="warehouse-department">NECS CORPORATE · PROCUREMENT & SUPPLY</p><h1 className="text-4xl sm:text-5xl font-bold mt-3" style={{ fontFamily: 'Barlow Condensed, sans-serif' }} data-testid="warehouse-title">Warehouse</h1>
      {user.shift_schedule && <p className="text-sm text-zinc-300 mt-3" data-testid="warehouse-assigned-schedule">{user.shift_schedule.label}</p>}
    </header><WarehouseInventory/>
  </div></main>;
}